module.exports = __webpack_public_path__ + "static/AirPlay-8ef94b12f302aa171989026f2632dc91.png";